import PropTypes from 'prop-types';
import { memo } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

import { TopicLoadingCard } from './TopicLoadingCard';
import TopicsAsGrid from './TopicsAsGrid';
import TopicsAsLane from './TopicsAsLane';
import TopicsBreadcrumb from './TopicsBreadcrumb';
import { LANE } from '../constants/displayAs';
import getUniqueKeyForTopics from '../utils/getUniqueKeyForTopics';

const Topics = ({
  dataTestId = 'topics-index',
  name,
  topics,
  totalTopics,
  isFetchingTopics,
  displayAs = LANE,
  onSeeAll,
  loadNextPage,
  updateTopicApproval,
  LoadingItemComponent = TopicLoadingCard,
  displayBreadcrumb = true,
}) => {
  const isTopicLoadingCards = isFetchingTopics || topics.length === 0;

  const TopicsItems = displayAs === LANE ? TopicsAsLane : TopicsAsGrid;

  return totalTopics === 0 && !isFetchingTopics ? null : (
    <Box flexDirection="column" data-testid={dataTestId}>
      {displayBreadcrumb && (
        <Grid>
          <Row mb={5}>
            <Col width={12 / 12}>
              <TopicsBreadcrumb
                displayAs={displayAs}
                isTopicLoadingCards={isTopicLoadingCards}
                name={name}
                onSeeAll={onSeeAll}
                totalTopics={totalTopics}
              />
            </Col>
          </Row>
        </Grid>
      )}
      <Box flexWrap="wrap" mb={8}>
        <TopicsItems
          loading={isTopicLoadingCards}
          topics={topics}
          total={totalTopics}
          loadNextPage={loadNextPage}
          updateTopicApproval={updateTopicApproval}
          LoadingItemComponent={LoadingItemComponent}
        />
      </Box>
    </Box>
  );
};

Topics.protoTypes = {
  dataTestId: PropTypes.string,
  name: PropTypes.string,
  topics: PropTypes.array,
  totalTopics: PropTypes.number,
  isFetchingTopics: PropTypes.bool,
  displayAs: PropTypes.string,
  loadNextPage: PropTypes.func,
  updateTopicApproval: PropTypes.func,
  LoadingItemComponent: PropTypes.elementType,
  displayBreadcrumb: PropTypes.bool,
};

export default memo(Topics, (prev, next) => {
  const prevIds = getUniqueKeyForTopics(prev.topics);
  const nextIds = getUniqueKeyForTopics(next.topics);

  return (
    prev.displayAs === next.displayAs &&
    prev.name === next.name &&
    prevIds === nextIds &&
    prev.totalTopics === next.totalTopics &&
    prev.isFetchingTopics === next.isFetchingTopics &&
    prev.onSeeAll === next.onSeeAll &&
    prev.loadNextPage === next.loadNextPage &&
    prev.updateTopicApproval === next.updateTopicApproval &&
    prev.LoadingItemComponent === next.LoadingItemComponent
  );
});
